interface AlertBadgeProps {
  label: string
  className?: string
}

export function AlertBadge({ label, className = '' }: AlertBadgeProps) {
  return (
    <span
      className={`bg-[#CC5C2D] inline-block px-[14px] py-[5px] rounded-[8px] text-white 
        text-[11px] font-[500] uppercase tracking-[1px] w-max ${className}`}
    >
      {label.toUpperCase()}
    </span>
  )
}
